import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-tension-locative',
    templateUrl: './tension-locative.component.html',
    styleUrls: ['./tension-locative.component.scss']
})
export class TensionLocativeComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }

}
